import { render, staticRenderFns } from "./yujing.vue?vue&type=template&id=48ce8315&"
import script from "./yujing.vue?vue&type=script&lang=js&"
export * from "./yujing.vue?vue&type=script&lang=js&"
import style0 from "./yujing.vue?vue&type=style&index=0&id=48ce8315&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports